import { useQuery } from "@tanstack/react-query";

import { telemetryAjax } from "../../ajax/TelemetryAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { BlastPatternFenceDTO } from "../../DTOs/Telemetry/BlastPatternFenceDTO";

export const BLAST_PATTERN_FENCE_QUERY_KEY = ["telemetry", "blastPatternFences"];

export function useBlastPatternFences(): BlastPatternFenceDTO[] {
  const { data = [] } = useQuery({
    queryKey: BLAST_PATTERN_FENCE_QUERY_KEY,
    queryFn: async () => {
      const res = await telemetryAjax.getLiveBlastPatternFences();
      // Note: this endpoint returns the array directly rather than a PagedResult, matching
      // telemetry/positions/current - so the error guard is the only unwrapping needed.
      if (ErrorResponse.isErrorResponse(res)) return [] as BlastPatternFenceDTO[];
      return res;
    },
    staleTime: 5 * 60 * 1000,
  });

  return data;
}
